<template>
  <NavBar v-if="!isMobile()"></NavBar>
  <NavBarmob v-if="isMobile()"></NavBarmob>
  <MovieBanner :movieDetails="moviedetails"></MovieBanner>
 
  <main>
    <section class="content-section moviebg " data-background="#ffffff" style="padding-bottom: 30px;">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">

            <div class="movie-info-box">
              <MovieHeading></MovieHeading>
              <DatePicker :totalPages="lastPage" :currentPage="currentPage" @pagechanged="onPageChange"
                :dates="datePages">
              </DatePicker>

              <FilmDetails :movieDetail="moviedetails" :showtimes="currentShowtime" @selectedshows="shows"></FilmDetails>
            </div>
          </div>
          <FilmPoster :movieDetail="moviedetails"></FilmPoster>
        </div>
      </div>
    </section>
    <!-- <Content :movieDetails="moviedetails" ref="content"></Content> -->
    <SiteFooter v-if="!isMobile()"></SiteFooter>
    <Footermob v-if="isMobile()"></Footermob>
  </main>
  <!-- large modal -->
  <div class="modal fade" id="largeModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body logpop">
          <div class="row pad50">
            <div class="col-md-7">
              <div class="membership marb3" v-if="!registerpg && !forgot">
                <h6>Get Started</h6>
                <p class="xsfon13">Sign in to your Palaxi Cinemas account to see your booking history and profile setting
                </p>
                <form name="frmTicket" id="frmTicket" @submit.prevent="loginSubmit">
                  <div class="or">


                    <!-- <a href="#" class="facbg"><i class="lni lni-facebook-filled"></i>
                      <small>with Facebook</small>
                    </a>  -->
                    <a href="#" class="gool">
                    <GoogleLogin :callback="googleCallback" prompt auto-login  v-if="!customer.loginCode" popup-type="TOKEN">
         <i class="lni lni-google"></i>
                      <small>with Google+</small>
          </GoogleLogin>
        </a>

                    <!-- <a href="#" class="gool"><i class="lni lni-google"></i>
                      <small>with Google+</small>
                    </a> -->

                    <span>or</span>
                  </div>



                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model='logindt.username'>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <input :type="passwrdfieldType" placeholder="Password" v-model="logindt.pwd">
                    <i :class="passwordIcon" @click="TogglePassword" aria-hidden="true"></i>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot = true, login = false"><input type="checkbox"
                        checked="true">
                      Forgot Password?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; "
                      @click="registerpg = true, login = false"><input type="checkbox" checked="true">
                      Member Registration
                    </a>
                  </div>
                  <div id="msgWrap" class="text-warning">{{ logindt.error }}</div>

                  <!-- end form-group -->
                  <div class="form-group">
                    <input type="submit" :value="logindt.clicked ? 'Processing..' : 'LOGIN'" :disabled="logindt.clicked">
                  </div>
                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
              <!--Register-->
              <div class="membership marb3" v-if="!login && !forgot">
                <h6>Signing Up</h6>
                <p class="xsfon13">Sign up to your Palaxi Cinemas account to see your booking history and profile setting
                </p>
                <form name="frmRegister" id="frmRegister" @submit.prevent="regSubmit()">
                  <div class="form-group">
                    <input type="text" placeholder="Name" v-model="register.name">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="Mobile No" v-model="register.mobile">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model="register.email">
                  </div>
                  <!-- end form-group -->

                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot = true, registerpg = false"><input type="checkbox"
                        checked="true"> Forgot Password?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; "
                      @click="login = true, registerpg = false"><input type="checkbox" checked="true">
                      Already Connected?
                    </a>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <div id="msgWrap" v-html="register.msg"></div>
                    <input type="submit" :value="register.clicked ? 'Processing..' : 'Register'"
                      :disabled="register.clicked">
                  </div>
                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
              <!--Register-->
              <!-- end membership -->
              <!--Forgot-->
              <div class="membership marb3" v-if="!login && !registerpg">
                <h6>Forgot Password ?</h6>
                <p class="xsfon13">Please provide your registered email ID, we will send the reset password to your inbox.
                </p>
                <form name="frmforgot" id="frmforgot" @submit.prevent="recoverPwd">

                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model="forgotpwd.email">
                  </div>
                  <!-- end form-group -->

                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot = false, login = true"><input type="checkbox"
                        checked="true">
                      Already Connected?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; "
                      @click="forgot = false, registerpg = true"><input type="checkbox" checked="true">
                      Member Registration
                    </a>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <input type="submit" :value="forgotpwd.clicked ? 'Processing' : 'RESET'"
                      :disabled="forgotpwd.clicked">
                  </div>
                  <div id="msgWrap" v-html="forgotpwd.msg"></div>

                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
              <!--Forgot-->





            </div>
            <div class="col-md-5 ">

              <div class="membership marb3">
                <h6>Book as guest?</h6>
              </div>
              <p class="xsfon13">As a guest, you may miss out on offers and other account features.</p>
              <div class="form-group">
                <a id="dismismod" class=" contbtn" data-dismiss="modal" @click="gotoseatlayout">Continue</a>

                <!-- <a id="dismis" class=" contbtn" data-dismiss="modal" >Continue</a> -->
                <!-- <router-link :to="'seatlayout/'+showId" class=" contbtn" data-dismiss="modal">Continue</router-link> -->
              </div>
            </div>
            <div> </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="smallmodal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true"
    v-if="ison == true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body logpop">
          <div class="row pad50">
            Specified show tickets not available online.Please visit the box office!!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/UI/NavBar.vue';
import SiteFooter from '@/components/UI/SiteFooter.vue';
// import Content from './ContentSection.vue';
import MovieBanner from './MovieBanner.vue';
import axios from 'axios';
import { URL } from '@/conf';
import DatePicker from './DatePicker.vue';
import MovieHeading from './MovieHeading.vue';
import FilmDetails from './FilmDetails.vue';
import FilmPoster from './FilmPoster.vue';
import NavBarmob from '../../UI/NavBarmob.vue';
import Footermob from '../../Indexmobile/IndexFooter.vue';
import { decodeCredential } from "vue3-google-login";

export default {
  data() {
    return {
      imgPath: process.env.BASE_URL,
      moviedetails: {},
      days: { "0": "Sun", "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat" },
      months: { "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun", "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec" },
      showDates: [],
      showTimes: [],
      bookedSeats: {},
      currentShowtime: [],
      datePages: {},
      ison: false,
      currentPage: 0,
      showId: null,
      register: { name: null, mobile: null, email: null, clicked: null, msg: null },
      lastPage: 0,
      forgotpwd: { clicked: null, email: null, msg: null },
      forgotpasswrd: false,
      registerpg: false,
      login: true,
      forgot: false,
      logindt: { code: localStorage.getItem("loginCode"), username: null, pwd: null, error: null },
      customer: {
        loginCode: localStorage.getItem("loginCode"),
        mobile: null,
        email: null,
        name: null,
      },
      passwordVisible: false,
      passwordIcon: "lni lni-eye",
      passwrdfieldType: "password",
      logSelector: false,



    }
  },
  components: {
    NavBar,
    SiteFooter,
    NavBarmob,
    Footermob,
    MovieBanner,
    DatePicker,
    MovieHeading,
    FilmDetails,
    FilmPoster,


  },
  mounted() {
    this.pageheader();
    this.GetMovieDetail();


  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    regSubmit() {
      this.register.msg = "<div class='text-danger'>";
      var valid = true;
      if (!this.register.name) {
        valid = false;
        this.register.msg += 'Name cannot be empty<br>';
      }
      if (!this.register.email) {
        valid = false;
        this.register.msg += 'Please enter your Email ID<br>';
      } else if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.register.email)) {
        this.register.msg += 'Email ID is not valid<br>';
        valid = false;
      }
      const filter = /^\d{10}$/;
      if (!filter.test(this.register.mobile)) {
        valid = false;
        this.register.msg += "Enter a valid 10 digit mobile number (without leading zero and +91)<br>";
      }
      this.register.msg += "</div>";
      if (valid) {
        this.register.clicked = true;
        axios.post(URL + "register", this.register, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
          }
        }).then((response) => {
          this.register.clicked = false;
          if (response.data.status == "done") {
            this.register.msg = response.data.msg;
            var that = this;
            setTimeout(function () {
              that.loginpage = true;
              that.register = { name: null, email: null, mobile: null, msg: null };
            }, 2000);
          } if (response.data.status == "error") {
            this.register.msg = response.data.msg;
          }
        }).catch(() => {
          this.register.clicked = false;
          this.register.msg = "<div class='text-danger'>Something went wrong please try again</div>";
        })
      }
    },
    shows(selected, ison) {
      if (ison == 1) {
        this.ison = true;
      }
      else {
        this.showId = selected;
      }
    },
    TogglePassword() {
      if (this.passwordIcon === "fa fa-eye-slash") {
        this.passwordIcon = "lni lni-eye";
      } else this.passwordIcon = "fa fa-eye-slash";
      if (this.passwrdfieldType == "password") {
        this.passwrdfieldType = "text";
      } else this.passwrdfieldType = "password";
    },
    gotoseatlayout() {

      this.$router.push({
        path: "../seatlayout/" + this.showId, state: {
          modal: false,
        }
      });

    },
    async pageheader() {
      var mastHeight = document.querySelector('.page-header, .slider').clientHeight;
      document.querySelector('main').style.marginTop = mastHeight + "px";
    },
    GetMovieDetail() {
      axios.get(URL + "movie/" + this.$route.params.slug).then((response) => {
        this.moviedetails = response.data.result;
      }).then(() => {
        axios.get(URL + "showtime/1/" + this.moviedetails.id).then((response) => {
          this.showTimes = response.data.result.showtime;
          this.getBooked();
          this.populatePage();
          this.setCurShowTime();
        })
      })
    },
    getBooked() {
      axios.get(URL + "seatcount/1/" + this.moviedetails.id).then((response) => {
        this.bookedSeats = response.data.result.booked;
      }).then(() => {
        this.setCurShowTime();
      }
      )
    },

    populatePage() {
      this.showDates = Object.keys(this.showTimes);
      this.datePages = [];
      this.lastPage = this.showDates.length;
      for (var i = 0; i < this.lastPage; i++) {
        var splited = this.showDates[i].split("-");
        var pg = { "day": this.days[splited[3]] + " " + splited[2], "mth": this.months[splited[1]] }
        this.datePages.push(pg);
      }


    },
    recoverPwd() {
      this.register.msg = "<div class='text-danger'>";
      var valid = true;

      if (!this.forgotpwd.email) {
        valid = false;
        this.forgotpwd.msg += 'Please enter your Email ID<br>';
      } else if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.forgotpwd.email)) {
        this.forgotpwd.msg += 'Email ID is not valid<br>';
        valid = false;
      }
      this.register.msg += "</div>";
      if (valid) {
        this.forgotpwd.clicked = true;
        axios.post(URL + "forgotPwd", this.forgotpwd, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
          }
        }).then((response) => {
          this.forgotpwd.clicked = false;
          if (response.data.status == "done") {
            this.forgotpwd.msg = response.data.msg;
            var that = this;
            setTimeout(function () {
              that.loginpage = true;
              that.forgotpasswrd = false;
              that.forgotpwd = { email: null, msg: null };
            }, 2000);
          } if (response.data.status == "error") {
            this.forgotpwd.msg = response.data.msg;
          }
        }).catch(() => {
          this.forgotpwd.clicked = false;
          this.forgotpwd.msg = "<div class='text-danger'>Something went wrong please try again</div>";
        })
      }
    },
    loginSubmit() {
      if (this.logindt.username && this.logindt.pwd) {
        this.logindt.clicked = true;
        axios.post(URL + "login", this.logindt, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
          }
        }).then((response) => {
          this.logindt.clicked = false;
          if (response.data.status == "done") {
            this.logSelector = false;
            this.customer.loginCode = response.data.customer;
            localStorage.setItem("loginCode", response.data.customer.loginCode);
            document.getElementById('dismismod').click();
            // this.$router.push("../seatlayout/"+this.showId);

          } if (response.data.status == "error") {
            this.logindt.error = response.data.msg;
          } else {
            this.logindt.error = "Please check your credentials";
          }
        }).catch(() => {

        })
      } else {
        this.logindt.error = "Please check your credentials";
      }
    },
    setCurShowTime() {
 if(this.showTimes){
              this.currentShowtime=this.showTimes[this.showDates[this.currentPage]];
              for (let stimeId in this.currentShowtime) {
                let replastimeId=stimeId.replace("_", "");
    let stime = this.currentShowtime[stimeId];
    stime["booked"] = this.bookedSeats ? this.bookedSeats[replastimeId] : 0;
}

              }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.setCurShowTime();
    },
    googleCallback(response) {
      // decodeCredential will retrive the JWT payload from the credential
      var social;
      if(response.credential)
      {
        const userData = decodeCredential(response.credential);
        social={"platform":"google","id":userData.sub,"name":userData.name,"email":userData.email}
      }
    if(response.access_token)
    {
    social={"platform":"google","token":response.access_token}      
    }
    console.log(social);
           this.pushSocialData(social);
    },
    pushSocialData(filds){
      axios.post(URL + "socialLogin",filds,{headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        }}).then((response) => {
         this.logSelector=false;
         if(response.data.status=="done")
         {

          this.customer.loginCode=response.data.social;
          this.customer.name=response.data.name;
          this.customer.email=response.data.email;
          this.customer.mobile=response.data.mobile;
          localStorage.setItem("loginCode",response.data.social);
          document.getElementById('dismismod').click();

     }
      }).catch(()=>{

      })
    }

  },
  props: {
    type: { type: String, default: "password" },
  },
  watch: {
    type(val) {
      this.fieldType = val;
    }
  },

}
</script>


<style type="text/css" media="screen">
.pagination__item {
  width: 51px;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  align-content: center;
  font-size: 1.1rem;
}

.pagination__list {
  list-style-type: none;
}

.pagination__item>button {
  width: 60px;
  height: 45px;
  font-size: 9px;
  color: #000;
}

.pagination__item>button,
.pagination__button {
  border: none;
  outline: none;
  stroke: none;
  box-shadow: none;
  cursor: pointer;
  border-radius: 9px;
  background: var(--color-gray);
}

.pagination__list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 350;
  height: 50px;
  border-radius: 9px;
  margin: 0 9px;
  overflow: hidden;
}

.pagination,
.pagination__list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  align-content: center;
}

.pagination__item>button:hover,
.pagination__button:hover {
  background-image: linear-gradient(135deg, rgba(174, 1, 94, 1) 1%, rgba(222, 12, 100, 1) 16%, rgba(235, 18, 89, 1) 30%, rgba(239, 82, 69, 1) 67%, rgba(244, 121, 45, 1) 83%, rgba(254, 187, 23, 1) 100%);
  color: #fff;
}

.pagination__button {
  width: 35px;
  height: 35px;
}

.pagination__item>button,
.pagination__button {
  border: none;
  outline: none;
  stroke: none;
  box-shadow: none;
  cursor: pointer;
  border-radius: 9px;
  background: var(--color-gray);
}

.pagination__item>button,
.pagination__button {
  stroke: none;
  cursor: pointer;
}

.pagination__item>.active {
  background-image: linear-gradient(135deg, rgba(174, 1, 94, 1) 1%, rgba(222, 12, 100, 1) 16%, rgba(235, 18, 89, 1) 30%, rgba(239, 82, 69, 1) 67%, rgba(244, 121, 45, 1) 83%, rgba(254, 187, 23, 1) 100%);
  color: #fff;
}</style>